import { useRef } from "react";
import { motion, useInView } from "motion/react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { siteData } from "../../data/mock";

const spring = { type: "spring", damping: 80, stiffness: 400, mass: 1 };

export const FAQSection = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section ref={ref} id="faq" className="py-20 md:py-28 bg-[#FAFAFA]">
      <div className="max-w-[800px] mx-auto px-6 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ ...spring }}
          className="text-center mb-14"
        >
          <span className="inline-block text-[#008055] text-sm font-medium bg-[#008055]/8 rounded-full px-4 py-1.5 mb-4">
            FAQ
          </span>
          <h2
            className="text-[#0A0A0A] leading-tight tracking-tight"
            style={{ fontSize: "clamp(28px, 4vw, 40px)", fontWeight: 500 }}
          >
            Frequently Asked <span className="text-[#008055]">Questions</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ ...spring, delay: 0.2 }}
        >
          <Accordion type="single" collapsible className="space-y-3">
            {siteData.faq.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="bg-white rounded-2xl border border-[#E6E4EB] px-6 data-[state=open]:border-[#008055]/30 data-[state=open]:shadow-sm"
                style={{ transition: "border-color 0.3s ease, box-shadow 0.3s ease" }}
              >
                <AccordionTrigger className="text-[#0A0A0A] text-base font-medium hover:no-underline py-5 [&[data-state=open]>svg]:text-[#008055]">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-[#3C3B3D] text-[15px] leading-relaxed pb-5">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
